// extracted by mini-css-extract-plugin
export default {"description":"style_description__KJM9m","fade-in":"style_fade-in__XO6oM","top":"style_top__BOTZ5","image":"style_image__7ywW6"};